import * as React from 'react';

import cn from 'classnames';

import { ReactFCC } from '@notino/react-styleguide';

import { desktopVisibleLg, mobileVisibleLg } from '@styles/common';

import { IExpandableTextProps } from './model';
import {
  Gradient,
  ExpandableTextWrapper,
  DefaultExpandableTextButton,
  mobileWrapperClass,
  desktopWrapperClass,
} from './styled';

export const ExpandableText: ReactFCC<IExpandableTextProps> = ({
  isExpanded: isExpandedProp,
  buttonText,
  onClick,
  children,
  useOnlyOn,
  height,
  disabled,
  gradientBgColor,
  gradientClassName,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const isControlledComponent = isExpandedProp !== undefined;

  const resolvedIsExpanded = isControlledComponent
    ? isExpandedProp
    : isExpanded;

  const handleClick = () => {
    if (isControlledComponent) {
      onClick?.();
      return;
    }
    setIsExpanded(true);
  };

  if (disabled) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  return (
    <>
      <ExpandableTextWrapper
        isExpanded={resolvedIsExpanded}
        height={height}
        className={cn({
          [mobileWrapperClass]: useOnlyOn === 'mobile',
          [desktopWrapperClass]: useOnlyOn === 'desktop',
        })}
      >
        {children}

        {!resolvedIsExpanded && (
          <Gradient
            data-testid="expandable-text-gradient"
            bgColor={gradientBgColor}
            className={cn({
              [mobileVisibleLg]: useOnlyOn === 'mobile',
              [desktopVisibleLg]: useOnlyOn === 'desktop',
              gradientClassName,
            })}
          />
        )}
      </ExpandableTextWrapper>

      {!resolvedIsExpanded &&
        getButtonComponent({ useOnlyOn, buttonText, handleClick })}
    </>
  );
};

const getButtonComponent = ({
  useOnlyOn,
  handleClick,
  buttonText,
}: Pick<IExpandableTextProps, 'useOnlyOn' | 'buttonText'> & {
  handleClick: () => void;
}) => {
  const btnCommonProps = {
    onClick: handleClick,
    ['data-testid']: 'expandable-text-button',
    className: cn({
      [mobileVisibleLg]: useOnlyOn === 'mobile',
      [desktopVisibleLg]: useOnlyOn === 'desktop',
    }),
  };

  return typeof buttonText === 'string' ? (
    <div {...btnCommonProps}>
      <DefaultExpandableTextButton>{buttonText}</DefaultExpandableTextButton>
    </div>
  ) : (
    <div {...btnCommonProps}>{buttonText}</div>
  );
};
